import Constants from "@/resources/Constants";
import * as Entities from "@/resources/Entities";

import {
  filterCriteria as msoCouponFilterCriteria,
  searchColumnHeaders as msoCouponColumnHeaders,
} from "../MSOCoupon/inputs";

import {
  filterCriteria as groupFilterCriteria,
  searchColumnHeaders as groupColumnHeaders,
} from "../Group/inputs";

import {
  filterCriteria as supplierFilterCriteria,
  searchColumnHeaders as supplierColumnHeaders,
} from "../Supplier/inputs";

import {
  filterCriteria as brandFilterCriteria,
  searchColumnHeaders as brandColumnHeaders,
} from "../Brand/inputs";

import {
  filterCriteria as productFilterCriteria,
  searchColumnHeaders as productColumnHeaders,
} from "../Product/inputs";

// Page Header
export const pageHeader = {
  title: "Coupon",
  isEditorView: true,
  cancelPath: "coupons",
  addPath: "couponEditor",
  buttonLabel: "Save",
};

// Page Header
export const listPageHeader = {
  title: "Coupons",
  isEditorView: false,
  buttonLabel: "New",
  routerPath: "couponEditor",
};

export const filterCriteria = [
  {
    label: "Name",
    code: "name",
    numCharsToSearch: 1,
    field: { type: "input", label: "name" },
    isPartial: true,
  },
  { label: "Brand", code: "brandName", field: { type: "input", label: "Brand" }, isPartial: true, },
  { label: "Group", code: "groupName", field: { type: "input", label: "Group" }, isPartial: true, },
  { label: "Product", code: "productName", field: { type: "input", label: "Product" }, isPartial: true, },
  { label: "Supplier", code: "supplierName", field: { type: "input", label: "Supplier" }, isPartial: true, },
  {
    label: "Accounting Code",
    code: "code",
    numCharsToSearch: 1,
    field: { type: "input", label: "code" },
    isPartial: true,
  },

  { label: "Id", code: "_id", field: { type: "input", label: "Id" } },
];

export const columnHeaders = [
  {
    id: "open",
    type: "button",
    action: "navigateToEntity",
    position: "sticky",
    iconName: "folder-open",
    ariaLabel: "Open",
  },
  {
    title: "Active",
    id: "isActive",
    type: "checkbox",
  },
  {
    title: "Archived",
    id: "isArchived",
    type: "checkbox",
  },
  {
    title: "Name",
    id: "name",
    size: "large",
  },
  {
    title: "Supplier",
    id: "supplier.name",
    size: "large",
  },
  {
    title: "Group",
    id: "group.name",
    size: "large",
  },
  {
    title: "Brand",
    id: "brand.name",
    size: "large",
  },
  {
    title: "Product",
    id: "product.name",
    size: "large",
  },
  {
    title: "Code",
    id: "code",
    size: "medium",
  },
  {
    id: "discountPercentage",
    title: "%",
  },
  {
    id: "discountAmount",
    title: "Discount Amount",
  },
  {
    id: "startDate",
    title: "Start Date",
    type: "date-extended"
  },
  {
    id: "endDate",
    title: "End Date",
    type: "date-extended"
  },
  {
    id: "applyDateRange",
    type: "checkbox",
    title: "Apply Date Range",
  },
  {
    id: "customerOnly",
    type: "checkbox",
    title: "Customer Only",
  },
  {
    id: "isOneTimeUse",
    type: "checkbox",
    title: "One Time Use",
  },
  {
    id: "isForCannabisOnly",
    type: "checkbox",
    title: "Cannabis Only",
  },
  {
    title: "Id",
    id: "_id",
  },
];

export const searchColumnHeaders = [
  {
    id: "select",
    type: "button",
    action: "selectItem",
    position: "sticky",
    iconName: "hand-pointer",
    ariaLabel: "Open",
  },
  {
    title: "Name",
    id: "name",
    size: "large",
  },
  {
    title: "Supplier",
    id: "supplier.name",
    size: "large",
  },
  {
    title: "Group",
    id: "group.name",
    size: "large",
  },
  {
    title: "Brand",
    id: "brand.name",
    size: "large",
  },
  {
    title: "Product",
    id: "product.name",
    size: "large",
  },
  {
    id: "discountPercentage",
    title: "%",
  },
  {
    id: "discountAmount",
    title: "Amount",
  },
  {
    id: "startDate",
    title: "Start Date",
  },
  {
    id: "endDate",
    title: "End Date",
  },
  {
    id: "applyDateRange",
    type: "checkbox",
    title: "Apply Date Range",
  },
  {
    id: "isOneTimeUse",
    type: "checkbox",
    title: "One Time Use",
  },
  {
    title: "Id",
    id: "_id",
  },
  {
    title: "Store",
    id: "store",
  },
];

export const couponInfoInputs = [
  {
    id: "msoCoupon",
    placeholder: "Select MSO Coupon",
    type: "search",
    title: "MSO Coupon",
    label: "name",
    class: "grid-row-two-column",
    entity: Entities.MSOCOUPON,
    columnHeaders: msoCouponColumnHeaders,
    filterCriteria: msoCouponFilterCriteria,
    filter: {
      "isActive": true,
      $and: [
        { "isArchived": false },
        { "isDeleted": false },
      ]
    },
  },
  {
    id: "group",
    placeholder: "Group",
    type: "search",
    title: "Group",
    label: "name",
    entity: Entities.GROUP,
    columnHeaders: groupColumnHeaders,
    filterCriteria: groupFilterCriteria,
    isClearable: true,
  },
  {
    id: "supplier",
    placeholder: "Supplier",
    type: "search",
    title: "Supplier",
    label: "name",
    entity: Entities.SUPPLIER,
    columnHeaders: supplierColumnHeaders,
    filterCriteria: supplierFilterCriteria,
    isClearable: true,
  },
  {
    id: "brand",
    placeholder: "Brand",
    type: "search",
    title: "Brand",
    label: "name",
    entity: Entities.BRAND,
    columnHeaders: brandColumnHeaders,
    filterCriteria: brandFilterCriteria,
    isClearable: true,
  },
  {
    id: "product",
    placeholder: "Product",
    type: "search",
    title: "Product",
    label: "name",
    entity: Entities.PRODUCT,
    columnHeaders: productColumnHeaders,
    filterCriteria: productFilterCriteria,
    isClearable: true,
  },
  {
    id: "name",
    placeholder: "Coupon Name",
    type: "input",
    title: "Coupon Name",
    focus: true,
  },
  {
    id: "code",
    placeholder: "Accounting Code",
    type: "input",
    title: "Accounting Code",
  },
  {
    id: "size",
    type: "number",
    title: "Size (g)",
    precision: Constants.numericInput.defaultWeightPrecision,
  },
  {
    id: "discountPercentage",
    placeholder: "Discount %",
    type: "number",
    title: "Discount %",
    suffix: "%",
    precision: Constants.numericInput.percentagePrecision,
  },
  {
    id: "discountAmount",
    type: "money",
    prefix: "$",
    title: "Discount Amount",
  },
  {
    id: "startDate",
    placeholder: "Start Date",
    type: "calendar",
    title: "Start Date",
  },
  {
    id: "endDate",
    placeholder: "End Date",
    type: "calendar",
    title: "End Date",
  },
  {
    id: "applyDateRange",
    type: "checkbox",
    title: "Apply Date Range",
  },
  {
    id: "isOneTimeUse",
    type: "checkbox",
    title: "One Time Use",
  },
  {
    id: "isForCannabisOnly",
    type: "checkbox",
    title: "Cannabis Only",
  },
  {
    id: "isActive",
    type: "checkbox",
    title: "Active",
  },
  {
    id: "minimumQuantity",
    type: "number",
    title: "Minimum Quantity",
    precision: Constants.numericInput.defaultPrecision,
  },
  {
    id: "maximumQuantity",
    type: "number",
    title: "Maximum Quantity",
    precision: Constants.numericInput.defaultPrecision,
  },
  {
    id: "minSpending",
    type: "money",
    title: "Minimum Order Spend",
    prefix: '$',
    precision: Constants.numericInput.moneyPrecision,
  },
  {
    id: "customerOnly",
    type: "checkbox",
    title: "Registered Customers Only",
  },
  {
    id: "notes",
    placeholder: "Notes",
    type: "textarea",
    title: "Notes",
    class: "grid-row-two-column",
  },
];

export const defaultSelectedCoupon = {
  _id: "NEW",
  name: "",
  discountPercentage: 0,
  discountAmount: 0,
  msoCoupon: undefined,
  supplier: undefined,
  group: undefined,
  brand: undefined,
  product: undefined,
  size: "",
  startDate: "",
  endDate: "",
  applyDateRange: false,
  isOneTimeUse: false,
  notes: "",
  isActive: true,
  isArchived: false,
  isDeleted: false,
  isForCannabisOnly: false,
  goodFor: "",
  minimumQuantity: 0,
  maximumQuantity: 0,
  code: '',
  customerOnly: false,
  minSpending: 0,
};
